module.exports = __webpack_public_path__ + "static/media/Gilroy-Medium.32af39a9.eot";